import { render } from "./DonationSuccessDialog.vue?vue&type=template&id=1132dce4&scoped=true"
import script from "./DonationSuccessDialog.vue?vue&type=script&lang=js"
export * from "./DonationSuccessDialog.vue?vue&type=script&lang=js"

import "./DonationSuccessDialog.vue?vue&type=style&index=0&id=1132dce4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1132dce4"]])

export default __exports__